





import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class TitleField extends Vue {
  @Prop({ type: String }) currentTitle!: string;
}
